











































































import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import SeletorDeLojas from '@/components/loja/SeletorDeLojas.vue'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import axios, { CancelTokenSource } from 'axios'
import { DataOptions } from 'vuetify'
import { Loja } from '@/models'
import DataTableDeCrud from '@/components/ui/DataTableDeCrud.vue'
import { FindEmbalagemUseCase, SaveEmbalagemUseCase } from '@/usecases/produto/embalagem'
import { FindLojaUseCase } from '@/usecases'
import DialogoDeEdicaoDeEmbalagem from '@/components/produto/DialogoDeEdicaoDeEmbalagem.vue'
import { Embalagem } from '@/models/Embalagem'
@Component({
	components: {
		SeletorDeLojas,
		DataTableDeCrud,
		DialogoDeEdicaoDeEmbalagem,
	},
})
export default class TelaDeEmbalagens extends Vue {
	@Ref() dialogoDeEdicaoDeEmbalagem!: DialogoDeEdicaoDeEmbalagem

	carregandoDados = false
	filtroDeLojas: any[] = []
	cancelToken: CancelTokenSource | null = null
	embalagens: Embalagem[] = []
	dadosDaLojaCarregada = false
	lojaSelecionada: Loja | null = null
	busca: string | null = null

	paginacao: DataOptions = {
		page: 1,
		itemsPerPage: 10,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}
	totalRegistros = 0

	headers = [
		{ text: 'Descrição', value: 'nome', sortable: false },
		{ text: 'Comprimento(cm)', value: 'comprimento', sortable: false },
		{ text: 'Altura(cm)', value: 'altura', sortable: false },
		{ text: 'Peso(g)', value: 'peso', sortable: false },
		{ text: 'Largura(cm)', value: 'largura', sortable: false },
	]

	findEmbalagemUseCase = new FindEmbalagemUseCase()
	saveEmbalagemUseCase = new SaveEmbalagemUseCase()
	findLojaUseCase = new FindLojaUseCase()

	@Watch('filtroDeLojas')
	async aplicarFiltro() {
		this.carregandoDados = true
		try {
			if (!this.filtroDeLojas) {
				this.dadosDaLojaCarregada = false
				this.carregandoDados = false
				return
			}

			if (typeof this.filtroDeLojas === 'string') {
				this.cancelToken = axios.CancelToken.source()
				const params = {
					page: this.paginacao.page - 1,
					size: this.paginacao.itemsPerPage,		
					busca: this.busca,
				}
				
				const axiosConfig = {
					cancelToken: this.cancelToken.token,
				}
				const page = await this.findEmbalagemUseCase.listarPorLoja(this.filtroDeLojas, params, axiosConfig)
				this.totalRegistros = page.totalElements
				this.embalagens = page.content
				this.dadosDaLojaCarregada = true
				this.lojaSelecionada = await this.findLojaUseCase.findLojaById(this.filtroDeLojas)
			} else {
				this.dadosDaLojaCarregada = false
			}

		} catch (e) {
			AlertModule.setError(e)
		} finally {
			this.carregandoDados = false
		}
	}

	@Watch('paginacao', { deep: true })
	onChangePaginacao() {
		this.aplicarFiltro()
	}

	abrirDialogoDeCriarEmbalagem() {
		if (!this.lojaSelecionada) return

		const novaEmbalagem = {
			id: undefined,
			nome: '',
			comprimento: 0,
			peso: 0,
			largura: 0,
			altura: 0,
			categorias: [],
			loja: this.lojaSelecionada,
		} as Embalagem

		this.dialogoDeEdicaoDeEmbalagem.mostrar(novaEmbalagem)
	}

	abrirDialogoDeEditarEmbalagem(indice: number) {
		const embalagemEmEdicao = this.embalagens[indice]
		this.dialogoDeEdicaoDeEmbalagem.mostrar(embalagemEmEdicao)
	}
}
